import axios from "networking/axios/axios";
import * as endpoints from "networking/endpoints/endpoints";

export const deleteProductApi = async (id) =>
    Promise.resolve(axios.delete(endpoints.deleteProduct.replace("{id}", id)));
